import { css } from 'styled-components';
import { IconTimer } from '@/app/common/icons/libraryIcons';
import { Text, type TextVariant } from '@lmn/design-system';
import { useRoomAvailabilityAlertLabel } from '@/app/components/hotel-detail/hooks/useRoomAvailabilityAlertLabel';

type RoomAvailabilityAlertLabelProps = {
  roomsLeft: number;
  textVariant?: TextVariant;
  iconSize?: number;
};

export function shouldShowRoomAvailabilityAlertLabel(roomsLeft: number) {
  return roomsLeft >= 1 && roomsLeft <= 5;
}

export function RoomAvailabilityAlertLabel(props: RoomAvailabilityAlertLabelProps) {
  const { roomsLeft, textVariant = 'Body', iconSize = 16 } = props;
  const { show, label } = useRoomAvailabilityAlertLabel(roomsLeft);

  return show ? (
    <div
      css={css`
        color: ${({ theme }) => theme.commons.colors.warning600};
        display: flex;
        align-items: center;
        gap: 8px;
      `}
    >
      <IconTimer
        css={`
          width: ${iconSize}px;
          height: ${iconSize}px;
          flex-shrink: 0;
        `}
      />
      <Text variant={textVariant} color="textWarning">
        {label}
      </Text>
    </div>
  ) : undefined;
}
